export default __webpack_public_path__ + "static/media/2.422f409f.png";